// extracted by mini-css-extract-plugin
module.exports = {"loader":"AdminSpinner_loader__2PaOg","load3":"AdminSpinner_load3__1mXfF"};